// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"546":"c2881777a5eb6d70","8037":"36721aa7c54b5358","8967":"727973242bb33abd"}[chunkId] + ".css";
};